<template>
  <div class="navbar-wrapper fixed-top">
    <!-- Promo banner - Optimizado para móviles -->
    <div class="promo-banner">
      <div
        class="container px-3 py-2 d-flex justify-content-between gap-3 text-lg-start text-center align-items-center flex-wrap py-1">
        <div
          class="promo-text d-flex align-items-center justify-content-center flex-wrap gap-2 gap-md-3 text-white fw-light">
          <div class="promo-item">
            <a :href="contactMailto" class="text-white text-decoration-none fw-normal fs-6">
              <i class="fas fa-envelope"></i>
            </a>
          </div>
          <div class="promo-item d-none d-sm-block">
            <a :href="whatsappHref" target="_blank" rel="noopener noreferrer"
            class="text-white text-decoration-none fw-normal fs-6">
            <i class="fab fa-whatsapp"></i>
          </a>
          </div>
        </div>
        <div>
          <p class="m-0 text-white-50 d-lg-block d-none">
            Especialistas en cultivo. <a href="/productos" class="text-decoration-none text-white">Ver catálogo.</a>
          </p>
        </div>
        <div class="promo-links d-flex gap-3 gap-md-4">
          <a
            v-if="instagramUrl"
            :href="instagramUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="text-white text-decoration-none fw-normal fs-7"
          >
            <i class="fab fa-instagram"></i>
          </a>
          <a
            v-if="tiktokUrl"
            :href="tiktokUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="text-white text-decoration-none fw-normal fs-7"
          >
            <i class="fab fa-tiktok"></i>
          </a>
          <a
            v-if="youtubeUrl"
            :href="youtubeUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="text-white text-decoration-none fw-normal fs-7"
          >
            <i class="fab fa-youtube"></i>
          </a>
        </div>
      </div>
    </div>

    <!-- Navbar principal -->
    <nav class="navbar navbar-expand-lg pb-0">
      <div class="container py-2 pb-3 px-lg-3 px-0">
        <div class="d-flex align-items-center justify-content-between w-100 position-relative">
          <div class="d-none d-lg-flex gap-3">
            <!-- navlinks productos, nosotros, contacto -->
            <a href="/" class="nav-link text-white fs-6 ps-lg-0">Inicio</a>
            <a href="/productos" class="nav-link text-white fs-6 ps-lg-0">Productos</a>
            <a href="/nosotros" class="nav-link text-white fs-6 ps-lg-0">Nosotros</a>
            <a href="/contacto" class="nav-link text-white fs-6 ps-lg-0">Contacto</a>
          </div>
          <!-- Menu Toggle -->
            <button class="mobile-menu-toggle mobile-icon-btn d-lg-none d-block border-0" @click="toggleMobileMenu"
              :aria-expanded="isMobileMenuOpen" aria-label="Toggle navigation menu" type="button">
              <i class="fas text-white" :class="isMobileMenuOpen ? 'fa-times' : 'fa-bars'"></i>
            </button>
          <!-- Logo -->
          <a class="navbar-brand position-absolute start-50 translate-middle-x" href="/">
            <div class="brand-container">
              <img src="@/assets/images/logo.png" alt="Good Bareto Logo" class="logo-img img-fluid" width="150" height="200"/>
            </div>
          </a>

          <!-- Desktop Actions -->
          <div class="nav-actions d-none d-lg-flex align-items-center">
            <a @click.prevent="handleUserAccount" href="#"
              class="user-account text-decoration-none text-white d-flex align-items-center gap-2">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="navbar-svg-icon">
                <path d="M12 12.25C11.2583 12.25 10.5333 12.0301 9.91661 11.618C9.29993 11.206 8.81928 10.6203 8.53545 9.93506C8.25163 9.24984 8.17736 8.49584 8.32206 7.76841C8.46675 7.04098 8.8239 6.3728 9.34835 5.84835C9.8728 5.3239 10.541 4.96675 11.2684 4.82206C11.9958 4.67736 12.7498 4.75162 13.4351 5.03545C14.1203 5.31928 14.706 5.79993 15.118 6.41661C15.5301 7.0333 15.75 7.75832 15.75 8.5C15.75 9.49456 15.3549 10.4484 14.6517 11.1517C13.9484 11.8549 12.9946 12.25 12 12.25ZM12 6.25C11.555 6.25 11.12 6.38196 10.75 6.62919C10.38 6.87643 10.0916 7.22783 9.92127 7.63896C9.75098 8.0501 9.70642 8.5025 9.79323 8.93895C9.88005 9.37541 10.0943 9.77632 10.409 10.091C10.7237 10.4057 11.1246 10.62 11.561 10.7068C11.9975 10.7936 12.4499 10.749 12.861 10.5787C13.2722 10.4084 13.6236 10.12 13.8708 9.75003C14.118 9.38002 14.25 8.94501 14.25 8.5C14.25 7.90326 14.0129 7.33097 13.591 6.90901C13.169 6.48705 12.5967 6.25 12 6.25Z" fill="currentColor"/>
                <path d="M19 19.25C18.8019 19.2474 18.6126 19.1676 18.4725 19.0275C18.3324 18.8874 18.2526 18.6981 18.25 18.5C18.25 16.55 17.19 15.25 12 15.25C6.81 15.25 5.75 16.55 5.75 18.5C5.75 18.6989 5.67098 18.8897 5.53033 19.0303C5.38968 19.171 5.19891 19.25 5 19.25C4.80109 19.25 4.61032 19.171 4.46967 19.0303C4.32902 18.8897 4.25 18.6989 4.25 18.5C4.25 13.75 9.68 13.75 12 13.75C14.32 13.75 19.75 13.75 19.75 18.5C19.7474 18.6981 19.6676 18.8874 19.5275 19.0275C19.3874 19.1676 19.1981 19.2474 19 19.25Z" fill="currentColor"/>
              </svg>
              <div class="account-text">
                <span class="account-label">{{ username }}</span>
                <span class="badge badge-pill account-role bg-primary" v-if="isAdmin">
                  Admin
                </span>
                <span class="badge badge-pill account-role bg-success" v-else-if="isDistributor">
                  Distribuidor
                </span>
              </div>
            </a>
            <!-- Search button desktop -->
            <button class="desktop-search-btn ms-2 border-0 bg-transparent" @click="toggleSearchDrawer"
              aria-label="Search products" type="button">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="navbar-svg-icon">
                <path d="M10.77 18.3C9.2807 18.3 7.82485 17.8584 6.58655 17.031C5.34825 16.2036 4.38311 15.0275 3.81318 13.6516C3.24325 12.2757 3.09413 10.7616 3.38468 9.30096C3.67523 7.84029 4.39239 6.49857 5.44548 5.44548C6.49857 4.39239 7.84029 3.67523 9.30096 3.38468C10.7616 3.09413 12.2757 3.24325 13.6516 3.81318C15.0275 4.38311 16.2036 5.34825 17.031 6.58655C17.8584 7.82485 18.3 9.2807 18.3 10.77C18.3 11.7588 18.1052 12.738 17.7268 13.6516C17.3484 14.5652 16.7937 15.3953 16.0945 16.0945C15.3953 16.7937 14.5652 17.3484 13.6516 17.7268C12.738 18.1052 11.7588 18.3 10.77 18.3ZM10.77 4.74999C9.58331 4.74999 8.42327 5.10189 7.43657 5.76118C6.44988 6.42046 5.68084 7.35754 5.22672 8.45389C4.77259 9.55025 4.65377 10.7566 4.88528 11.9205C5.11679 13.0844 5.68824 14.1535 6.52735 14.9926C7.36647 15.8317 8.43556 16.4032 9.59945 16.6347C10.7633 16.8662 11.9697 16.7474 13.0661 16.2933C14.1624 15.8391 15.0995 15.0701 15.7588 14.0834C16.4181 13.0967 16.77 11.9367 16.77 10.75C16.77 9.15869 16.1379 7.63257 15.0126 6.50735C13.8874 5.38213 12.3613 4.74999 10.77 4.74999Z" fill="currentColor"/>
                <path d="M20 20.75C19.9015 20.7504 19.8038 20.7312 19.7128 20.6934C19.6218 20.6557 19.5392 20.6001 19.47 20.53L15.34 16.4C15.2075 16.2578 15.1354 16.0697 15.1388 15.8754C15.1422 15.6811 15.221 15.4958 15.3584 15.3583C15.4958 15.2209 15.6812 15.1422 15.8755 15.1388C16.0698 15.1354 16.2578 15.2075 16.4 15.34L20.53 19.47C20.6704 19.6106 20.7493 19.8012 20.7493 20C20.7493 20.1987 20.6704 20.3893 20.53 20.53C20.4608 20.6001 20.3782 20.6557 20.2872 20.6934C20.1962 20.7312 20.0985 20.7504 20 20.75Z" fill="currentColor"/>
              </svg>
            </button>

            <button @click="toggleMiniCart" class="cart-icon ms-0 border-0 bg-transparent position-relative" type="button" aria-label="Ver carrito">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="navbar-svg-icon">
                <path d="M19.5 8.25H16.5V7.75C16.5 6.55653 16.0259 5.41193 15.182 4.56802C14.3381 3.72411 13.1935 3.25 12 3.25C10.8065 3.25 9.66193 3.72411 8.81802 4.56802C7.97411 5.41193 7.5 6.55653 7.5 7.75V8.25H4.5C4.16848 8.25 3.85054 8.3817 3.61612 8.61612C3.3817 8.85054 3.25 9.16848 3.25 9.5V18C3.25 18.7293 3.53973 19.4288 4.05546 19.9445C4.57118 20.4603 5.27065 20.75 6 20.75H18C18.7293 20.75 19.4288 20.4603 19.9445 19.9445C20.4603 19.4288 20.75 18.7293 20.75 18V9.5C20.75 9.16848 20.6183 8.85054 20.3839 8.61612C20.1495 8.3817 19.8315 8.25 19.5 8.25ZM9 7.75C9 6.95435 9.31607 6.19129 9.87868 5.62868C10.4413 5.06607 11.2044 4.75 12 4.75C12.7956 4.75 13.5587 5.06607 14.1213 5.62868C14.6839 6.19129 15 6.95435 15 7.75V8.25H9V7.75ZM19.25 18C19.25 18.3315 19.1183 18.6495 18.8839 18.8839C18.6495 19.1183 18.3315 19.25 18 19.25H6C5.66848 19.25 5.35054 19.1183 5.11612 18.8839C4.8817 18.6495 4.75 18.3315 4.75 18V9.75H7.5V12C7.5 12.1989 7.57902 12.3897 7.71967 12.5303C7.86032 12.671 8.05109 12.75 8.25 12.75C8.44891 12.75 8.63968 12.671 8.78033 12.5303C8.92098 12.3897 9 12.1989 9 12V9.75H15V12C15 12.1989 15.079 12.3897 15.2197 12.5303C15.3603 12.671 15.5511 12.75 15.75 12.75C15.9489 12.75 16.1397 12.671 16.2803 12.5303C16.421 12.3897 16.5 12.1989 16.5 12V9.75H19.25V18Z" fill="currentColor"/>
              </svg>
              <span class="badge badge-pill cart-count" v-if="cartCount > 0">{{
                cartCount
              }}</span>
            </button>
          </div> 
          <!-- Mobile Actions - Enhanced for better UX -->
          <div class="mobile-actions d-lg-none ms-auto d-flex align-items-center">
            <!-- Mobile Search Button -->
            <button @click="toggleSearchDrawer"
              class="mobile-icon-btn me-2 d-flex align-items-center justify-content-center"
              aria-label="Search products">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="navbar-svg-icon">
                <path d="M10.77 18.3C9.2807 18.3 7.82485 17.8584 6.58655 17.031C5.34825 16.2036 4.38311 15.0275 3.81318 13.6516C3.24325 12.2757 3.09413 10.7616 3.38468 9.30096C3.67523 7.84029 4.39239 6.49857 5.44548 5.44548C6.49857 4.39239 7.84029 3.67523 9.30096 3.38468C10.7616 3.09413 12.2757 3.24325 13.6516 3.81318C15.0275 4.38311 16.2036 5.34825 17.031 6.58655C17.8584 7.82485 18.3 9.2807 18.3 10.77C18.3 11.7588 18.1052 12.738 17.7268 13.6516C17.3484 14.5652 16.7937 15.3953 16.0945 16.0945C15.3953 16.7937 14.5652 17.3484 13.6516 17.7268C12.738 18.1052 11.7588 18.3 10.77 18.3ZM10.77 4.74999C9.58331 4.74999 8.42327 5.10189 7.43657 5.76118C6.44988 6.42046 5.68084 7.35754 5.22672 8.45389C4.77259 9.55025 4.65377 10.7566 4.88528 11.9205C5.11679 13.0844 5.68824 14.1535 6.52735 14.9926C7.36647 15.8317 8.43556 16.4032 9.59945 16.6347C10.7633 16.8662 11.9697 16.7474 13.0661 16.2933C14.1624 15.8391 15.0995 15.0701 15.7588 14.0834C16.4181 13.0967 16.77 11.9367 16.77 10.75C16.77 9.15869 16.1379 7.63257 15.0126 6.50735C13.8874 5.38213 12.3613 4.74999 10.77 4.74999Z" fill="currentColor"/>
                <path d="M20 20.75C19.9015 20.7504 19.8038 20.7312 19.7128 20.6934C19.6218 20.6557 19.5392 20.6001 19.47 20.53L15.34 16.4C15.2075 16.2578 15.1354 16.0697 15.1388 15.8754C15.1422 15.6811 15.221 15.4958 15.3584 15.3583C15.4958 15.2209 15.6812 15.1422 15.8755 15.1388C16.0698 15.1354 16.2578 15.2075 16.4 15.34L20.53 19.47C20.6704 19.6106 20.7493 19.8012 20.7493 20C20.7493 20.1987 20.6704 20.3893 20.53 20.53C20.4608 20.6001 20.3782 20.6557 20.2872 20.6934C20.1962 20.7312 20.0985 20.7504 20 20.75Z" fill="currentColor"/>
              </svg>
            </button>

            <!-- Cart Icon -->
            <button
              @click="toggleMiniCart"
              class="mobile-icon-btn me-2 position-relative d-flex align-items-center justify-content-center border-0 bg-transparent"
              type="button"
              aria-label="Ver carrito"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="navbar-svg-icon">
                <path d="M19.5 8.25H16.5V7.75C16.5 6.55653 16.0259 5.41193 15.182 4.56802C14.3381 3.72411 13.1935 3.25 12 3.25C10.8065 3.25 9.66193 3.72411 8.81802 4.56802C7.97411 5.41193 7.5 6.55653 7.5 7.75V8.25H4.5C4.16848 8.25 3.85054 8.3817 3.61612 8.61612C3.3817 8.85054 3.25 9.16848 3.25 9.5V18C3.25 18.7293 3.53973 19.4288 4.05546 19.9445C4.57118 20.4603 5.27065 20.75 6 20.75H18C18.7293 20.75 19.4288 20.4603 19.9445 19.9445C20.4603 19.4288 20.75 18.7293 20.75 18V9.5C20.75 9.16848 20.6183 8.85054 20.3839 8.61612C20.1495 8.3817 19.8315 8.25 19.5 8.25ZM9 7.75C9 6.95435 9.31607 6.19129 9.87868 5.62868C10.4413 5.06607 11.2044 4.75 12 4.75C12.7956 4.75 13.5587 5.06607 14.1213 5.62868C14.6839 6.19129 15 6.95435 15 7.75V8.25H9V7.75ZM19.25 18C19.25 18.3315 19.1183 18.6495 18.8839 18.8839C18.6495 19.1183 18.3315 19.25 18 19.25H6C5.66848 19.25 5.35054 19.1183 5.11612 18.8839C4.8817 18.6495 4.75 18.3315 4.75 18V9.75H7.5V12C7.5 12.1989 7.57902 12.3897 7.71967 12.5303C7.86032 12.671 8.05109 12.75 8.25 12.75C8.44891 12.75 8.63968 12.671 8.78033 12.5303C8.92098 12.3897 9 12.1989 9 12V9.75H15V12C15 12.1989 15.079 12.3897 15.2197 12.5303C15.3603 12.671 15.5511 12.75 15.75 12.75C15.9489 12.75 16.1397 12.671 16.2803 12.5303C16.421 12.3897 16.5 12.1989 16.5 12V9.75H19.25V18Z" fill="currentColor"/>
              </svg>
              <span class="badge badge-pill cart-count" v-if="cartCount > 0">{{
                cartCount
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </nav>

    <!-- Desktop Offcanvas Menu (nuevo) -->
    <div class="desktop-offcanvas-menu" :class="{ show: isDesktopMenuOpen }">
      <div class="offcanvas-header">
        <div class="d-flex align-items-center">
          <h5 class="offcanvas-title fs-5">Categorías</h5>
        </div>
        <button type="button" class="btn-close" @click="closeDesktopMenu" aria-label="Close"></button>
      </div>

      <div class="offcanvas-body">
        <!-- Menu Accordion -->
        <div class="desktop-menu accordion" id="desktopMenuAccordion">
          <!-- Skeleton Loaders -->
          <div v-if="isLoadingCategories" class="desktop-skeleton-menu">
            <div v-for="index in 5" :key="index" class="desktop-skeleton-item">
              <div class="skeleton-button"></div>
            </div>
          </div>

          <!-- Categorías dinámicas -->
          <template v-else>
            <!-- Links fijos -->
             <div class="desktop-menu-item">
              <a href="/blog" class="desktop-link" @click="closeDesktopMenu">
                BLOG
              </a>
            </div>
            <div class="desktop-menu-item">
              <a href="/productos" class="desktop-link" @click="closeDesktopMenu">
                TODOS LOS PRODUCTOS
              </a>
            </div>

            <!-- Categorías padre -->
            <template v-for="category in parentCategories" :key="category.id">
              <!-- Categoría con subcategorías -->
              <div v-if="hasSubcategories(category.id)" class="accordion-item border-0">
                <h2 class="accordion-header" :id="'desktopHeading' + category.id">
                  <button class="accordion-button collapsed desktop-link" type="button" data-bs-toggle="collapse"
                    :data-bs-target="'#desktopCollapse' + category.id">
                    {{ category.name.toUpperCase() }}
                  </button>
                </h2>
                <div :id="'desktopCollapse' + category.id" class="accordion-collapse collapse"
                  :aria-labelledby="'desktopHeading' + category.id" data-bs-parent="#desktopMenuAccordion">
                  <div class="accordion-body p-0">
                    <div class="submenu-items">
                      <!-- Subcategorías (hijas) -->
                      <template v-for="subcat in getDirectSubcategories(category.id)" :key="subcat.id">
                        <!-- Subcategoría con nietas -->
                        <div v-if="hasSubcategories(subcat.id)" class="subcategory-with-children mb-3">
                          <a :href="'/productos?categories=' + subcat.name" class="submenu-link subcategory-parent-link"
                            @click="closeDesktopMenu">
                            {{ subcat.name }}
                          </a>
                          <div class="subcategory-children ps-3 mt-2">
                            <a v-for="grandchild in getDirectSubcategories(subcat.id)" :key="grandchild.id"
                              :href="'/productos?categories=' + grandchild.name" class="submenu-link subgrandchild-link"
                              @click="closeDesktopMenu">
                              {{ grandchild.name }}
                            </a>
                          </div>
                        </div>
                        <!-- Subcategoría sin nietas -->
                        <a v-else :href="'/productos?categories=' + subcat.name" class="submenu-link"
                          @click="closeDesktopMenu">
                          {{ subcat.name }}
                        </a>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Categoría sin subcategorías -->
              <div v-else class="desktop-menu-item">
                <a :href="'/productos?categories=' + category.name" class="desktop-link" @click="closeDesktopMenu">
                  {{ category.name.toUpperCase() }}
                </a>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>

    <!-- Overlay for desktop menu -->
    <div class="desktop-offcanvas-backdrop" :class="{ show: isDesktopMenuOpen }" @click="closeDesktopMenu"></div>

    <!-- Mobile Offcanvas Menu -->
    <div class="offcanvas-menu" :class="{ show: isMobileMenuOpen }">
      <div class="offcanvas-header">
        <div class="d-flex align-items-center">
          <h5 class="offcanvas-title">Categorías</h5>
        </div>
        <button
          type="button"
          class="btn-close"
          @click="closeMobileMenu"
          aria-label="Close"
        ></button>
      </div>

      <div class="offcanvas-body">
        <!-- Mobile Search Bar -->
        <div class="search-container mb-4 mx-0">
          <form @submit.prevent="handleSearch" class="input-group">
            <input
              type="text"
              class="form-control search-input fs-7"
              placeholder="Buscar productos..."
              v-model="searchQuery"
              aria-label="Search products"
            />
            <button class="btn search-btn" type="submit" aria-label="Search">
              <i class="fas fa-search"></i>
            </button>
          </form>
        </div>

        <!-- User Account Link -->
        <div class="mobile-user-account mb-4">
          <a
            @click.prevent="handleUserAccount"
            href="#"
            class="d-flex align-items-center p-2 rounded-3"
          >
            <i class="fas fa-user me-3 fs-5"></i>
            <div>
              <span class="d-block fw-medium">{{ username }}</span>
              <small class="text-muted">Mi cuenta</small>
            </div>
            <i class="fas fa-chevron-right ms-auto"></i>
          </a>
        </div>

        <!-- Menu Accordion - Igual que en desktop -->
        <div class="mobile-menu accordion" id="mobileMenuAccordion">
          <!-- Skeleton Loaders -->
          <div v-if="isLoadingCategories" class="mobile-skeleton-menu">
            <div v-for="index in 5" :key="index" class="mobile-skeleton-item">
              <div class="skeleton-button"></div>
            </div>
          </div>
          
          <!-- Categorías dinámicas -->
          <template v-else>
            <div class="mobile-menu-item">
              <a href="/productos" class="mobile-link" @click="closeMobileMenu">
                TODOS LOS PRODUCTOS
              </a>
            </div>
           
            
            <!-- Categorías padre -->
            <template v-for="category in parentCategories" :key="category.id">
              <!-- Categoría con subcategorías -->
              <div v-if="hasSubcategories(category.id)" class="accordion-item border-0">
                <h2 class="accordion-header" :id="'heading' + category.id">
                  <button class="accordion-button collapsed mobile-link" 
                          type="button" 
                          data-bs-toggle="collapse" 
                          :data-bs-target="'#collapse' + category.id">
                    {{ category.name.toUpperCase() }}
                  </button>
                </h2>
                <div :id="'collapse' + category.id" 
                     class="accordion-collapse collapse" 
                     :aria-labelledby="'heading' + category.id" 
                     data-bs-parent="#mobileMenuAccordion">
                  <div class="accordion-body p-0">
                    <div class="submenu-items mobile-submenu-items">
                      <!-- Subcategorías (hijas) -->
                      <template v-for="subcat in getDirectSubcategories(category.id)" :key="subcat.id">
                        <!-- Subcategoría con nietas -->
                        <div v-if="hasSubcategories(subcat.id)" class="subcategory-with-children mb-3">
                          <a :href="'/productos?categories=' + subcat.name" 
                             class="mobile-subcategory-link subcategory-parent-link"
                             @click="closeMobileMenu">
                            {{ subcat.name }}
                          </a>
                          <div class="mobile-subcategory-children ps-3 mt-2">
                            <a v-for="grandchild in getDirectSubcategories(subcat.id)" 
                               :key="grandchild.id"
                               :href="'/productos?categories=' + grandchild.name" 
                               class="mobile-grandchild-link subgrandchild-link"
                               @click="closeMobileMenu">
                              {{ grandchild.name }}
                            </a>
                          </div>
                        </div>
                        <!-- Subcategoría sin nietas -->
                        <a v-else
                           :href="'/productos?categories=' + subcat.name" 
                           class="mobile-subcategory-link"
                           @click="closeMobileMenu">
                          {{ subcat.name }}
                        </a>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Categoría sin subcategorías -->
              <div v-else class="mobile-menu-item">
                <a :href="'/productos?categories=' + category.name" 
                   class="mobile-link" 
                   @click="closeMobileMenu">
                  {{ category.name.toUpperCase() }}
                </a>
              </div>
            </template>
          </template>
        </div>
      </div>

      <!-- Social Links Footer -->
      <div class="offcanvas-footer">
        <div class="d-flex justify-content-between align-items-center">
          <div class="social-links-mobile">
            <a
              v-if="tiktokUrl"
              :href="tiktokUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link-mobile"
            >
              <i class="fab fa-tiktok"></i>
            </a>
            <a
              v-if="instagramUrl"
              :href="instagramUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link-mobile"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              :href="whatsappHref"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link-mobile"
            >
              <i class="fab fa-whatsapp"></i>
            </a>
          </div>
          <small class="text-muted">© {{ new Date().getFullYear() }}</small>
        </div>
      </div>
    </div>

    <!-- Overlay for mobile menu -->
    <div class="offcanvas-backdrop" :class="{ show: isMobileMenuOpen }" @click="closeMobileMenu"></div>

    <!-- Search Drawer -->
    <SearchDrawer :is-open="isSearchDrawerOpen" @close="closeSearchDrawer" />

    <!-- Mini Cart Drawer -->
    <MiniCartDrawer :is-open="isMiniCartOpen" @close="closeMiniCart" />
  </div>
</template>

<script>
import { computed, ref, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { getCategories } from '@/services/categories';
import MiniCartDrawer from './MiniCartDrawer.vue';
import SearchDrawer from './SearchDrawer.vue';
import { useSiteContact } from '@/composables/useSiteContact';

export default {
  name: "NavbarComponent",
  components: { MiniCartDrawer, SearchDrawer },
  data() {
    return {
      searchQuery: "",
      activeDropdown: null,
      isMobileMenuOpen: false,
      isDesktopMenuOpen: false,
      isMiniCartOpen: false,
      isSearchDrawerOpen: false,
      categories: [],
      isLoadingCategories: false,
      categoryError: null,
    };
  },
  created() {
    // Mejorar el logging para depuración
    this.loadCategories();
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const cartCount = computed(() => store.getters.cartCount);
    const username = ref("");
    const isAdmin = ref(false);
    const isDistributor = ref(false);
    const isAuthenticated = ref(false);

    const updateUserInfo = () => {
      const token = localStorage.getItem("accessToken");
      isAuthenticated.value = !!token;
      isAdmin.value = localStorage.getItem("isAdmin") === "true";
      isDistributor.value = localStorage.getItem("customerType") === "DISTRIBUTOR";

      if (isAuthenticated.value) {
        const firstName = localStorage.getItem("userFirstName");
        const lastName = localStorage.getItem("userLastName");
        if (firstName && lastName) {
          username.value = `${firstName} ${lastName}`;
        } else {
          username.value = localStorage.getItem("username") || "Usuario";
        }
      } else {
        username.value = "";
      }
    };

    onMounted(() => {
      updateUserInfo();
      window.addEventListener("storage", updateUserInfo);
    });

    // Limpiar el event listener cuando el componente se desmonta
    onUnmounted(() => {
      window.removeEventListener("storage", updateUserInfo);
    });

    const { contactMailto, whatsappHref, instagramUrl, tiktokUrl, youtubeUrl } = useSiteContact();

    return {
      cartCount,
      router,
      route,
      username,
      isAdmin,
      isDistributor,
      isAuthenticated,
      contactMailto,
      whatsappHref,
      instagramUrl,
      tiktokUrl,
      youtubeUrl,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.updateNavbarHeightVariables();
    window.addEventListener("resize", this.updateNavbarHeightVariables);

    // Initialize Bootstrap components if needed
    this.initBootstrapComponents();

    // Add scroll event listener for transparent navbar
    window.addEventListener("scroll", this.handleScroll);
    // Apply scrolled state immediately if not on home page
    this.handleScroll();
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("resize", this.updateNavbarHeightVariables);
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    parentCategories() {
      return this.categories.filter(cat => !cat.parent);
    }
  },
  watch: {
    $route() {
      this.handleScroll();
    }
  },
  methods: {
    initBootstrapComponents() {
      // Initialize Bootstrap accordion if not using data attributes
      if (window.bootstrap && window.bootstrap.Collapse) {
        const accordionItems = document.querySelectorAll(".accordion-collapse");
        accordionItems.forEach((item) => {
          new window.bootstrap.Collapse(item, { toggle: false });
        });
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      document.body.style.overflow = this.isMobileMenuOpen ? "hidden" : "";

      // Optional: Add animation effect
      const menuItems = document.querySelectorAll(
        ".mobile-link, .submenu-link"
      );
      if (this.isMobileMenuOpen) {
        menuItems.forEach((item, index) => {
          item.style.transitionDelay = `${index * 0.05}s`;
          item.style.opacity = 1;
          item.style.transform = "translateX(0)";
        });
      } else {
        menuItems.forEach((item) => {
          item.style.transitionDelay = "0s";
          item.style.opacity = 0;
          item.style.transform = "translateX(20px)";
        });
      }
    },

    toggleDesktopMenu() {
      this.isDesktopMenuOpen = !this.isDesktopMenuOpen;
      document.body.style.overflow = this.isDesktopMenuOpen ? "hidden" : "";

      // Animación similar a la del menú mobile
      const menuItems = document.querySelectorAll(
        ".desktop-link, .submenu-link"
      );
      if (this.isDesktopMenuOpen) {
        menuItems.forEach((item, index) => {
          item.style.transitionDelay = `${index * 0.05}s`;
          item.style.opacity = 1;
          item.style.transform = "translateX(0)";
        });
      } else {
        menuItems.forEach((item) => {
          item.style.transitionDelay = "0s";
          item.style.opacity = 0;
          item.style.transform = "translateX(20px)";
        });
      }
    },

    closeDesktopMenu() {
      if (this.isDesktopMenuOpen) {
        this.isDesktopMenuOpen = false;
        document.body.style.overflow = "";

        // Cerrar acordeones abiertos
        const accordions = document.querySelectorAll('.accordion-collapse.show');
        accordions.forEach(accordion => {
          if (window.bootstrap && window.bootstrap.Collapse) {
            const bsCollapse = new window.bootstrap.Collapse(accordion);
            bsCollapse.hide();
          }
        });

        // Reset menu items animation
        const menuItems = document.querySelectorAll('.desktop-link, .submenu-link');
        menuItems.forEach((item) => {
          item.style.transitionDelay = "0s";
          item.style.opacity = 0;
          item.style.transform = "translateX(20px)";
        });
      }
    },

    closeMobileMenu() {
      if (this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
        document.body.style.overflow = "";

        // Cerrar todos los acordeones abiertos
        const accordions = document.querySelectorAll('.accordion-collapse.show');
        accordions.forEach(accordion => {
          if (window.bootstrap && window.bootstrap.Collapse) {
            const bsCollapse = new window.bootstrap.Collapse(accordion);
            bsCollapse.hide();
          }
        });

        // Reset menu items animation
        const menuItems = document.querySelectorAll('.mobile-link, .submenu-link');
        menuItems.forEach((item) => {
          item.style.transitionDelay = "0s";
          item.style.opacity = 0;
          item.style.transform = "translateX(20px)";
        });
      }
    },

    toggleSearchDrawer() {
      this.isSearchDrawerOpen = !this.isSearchDrawerOpen;
    },

    closeSearchDrawer() {
      this.isSearchDrawerOpen = false;
    },
    updateNavbarHeightVariables() {
      // Get navbar wrapper element
      const navbarWrapper = document.querySelector(".navbar-wrapper");
      if (navbarWrapper) {
        // Calculate navbar height
        const navbarHeight = navbarWrapper.offsetHeight;

        // Set CSS variables
        document.documentElement.style.setProperty(
          "--navbar-total-height",
          `${navbarHeight}px`
        );

        // Also set a mobile version if screen is smaller
        if (window.innerWidth <= 991.98) {
          document.documentElement.style.setProperty(
            "--navbar-total-height-mobile",
            `${navbarHeight}px`
          );

          // Set optimized hero height for mobile based on screen height
          const screenHeight = window.innerHeight;
          let optimizedHeroHeight;

          if (window.innerWidth <= 480) {
            optimizedHeroHeight = Math.max(screenHeight * 0.6, 350); // 60% of screen or at least 350px
          } else if (window.innerWidth <= 768) {
            optimizedHeroHeight = Math.max(screenHeight * 0.7, 400); // 70% of screen or at least 400px
          } else {
            optimizedHeroHeight = Math.max(screenHeight * 0.7, 450); // 70% of screen or at least 450px
          }

          document.documentElement.style.setProperty(
            "--hero-height",
            `${optimizedHeroHeight}px`
          );

          // Set a background color that matches the products section
          document.documentElement.style.setProperty(
            "--hero-bg-color",
            "#f8f8f8"
          );
        } else {
          // Reset hero height for desktop
          document.documentElement.style.removeProperty("--hero-height");
          document.documentElement.style.removeProperty("--hero-bg-color");
        }
      }
    },
    handleResize() {
      if (window.innerWidth >= 992 && this.isMobileMenuOpen) {
        this.closeMobileMenu();
      }
    },
    handleSearch() {
      if (this.searchQuery.trim()) {
        this.router.push({
          path: "/productos",
          query: { search: this.searchQuery.trim() },
        });
        this.closeMobileMenu();
      }
    },
    handleUserAccount() {
      if (this.isAuthenticated) {
        if (this.isAdmin) {
          this.router.push("/configuracion/productos");
        } else {
          this.router.push("/configuracion/my-orders");
        }
      } else {
        this.router.push("/iniciar-sesion");
      }
      this.closeMobileMenu();
    }, handleScroll() {
      const navbar = document.querySelector(".navbar");
      const promoBanner = document.querySelector(".promo-banner");
      const isHome = this.route && this.route.path === "/";
      const isAboutUs = this.route && this.route.path === "/nosotros";

      if ((!isHome && !isAboutUs) || window.scrollY > 150) {
        // Aplicar estilos de scroll (siempre en páginas que no son home)
        if (navbar) navbar.classList.add("navbar-scrolled");
        if (promoBanner) promoBanner.classList.add("scrolled");
      } else {
        // Remover estilos de scroll (solo en home sin scroll)
        if (navbar) navbar.classList.remove("navbar-scrolled");
        if (promoBanner) promoBanner.classList.remove("scrolled");
      }
    },
    getCategoryIcon(categoryName) {
      const icons = {
        'ART. PARA FUMAR': 'fas fa-smoking',
        'PIPAS': 'fas fa-tag',
        'PICADORES': 'fas fa-mortar-pestle',
        'PAPELILLOS/FILTROS': 'fas fa-scroll',
        'ENCENDEDORES': 'fas fa-fire',
        'EXTRACCIONES': 'fas fa-vial',
        'BANDEJAS/LATAS': 'fas fa-box',
        'CENICEROS': 'fas fa-tag',
        'COSECHA': 'fas fa-scissors',
        'ARMADORES': 'fas fa-tools',
        'ARTICULOS INDOOR': 'fas fa-warehouse',
        'MEDICIÓN': 'fas fa-ruler-combined',
        'FERTILIZANTES': 'fas fa-flask',
        'FERTILIZANTES PARA CRECIMIENTO': 'fas fa-seedling',
        'FERTILIZANTES PARA FLORACION': 'fas fa-tag',
        'ENRAIZANTES': 'fas fa-tag',
        'BIOESTIMULANTES': 'fas fa-leaf',
        'CONTROL PLAGAS': 'fas fa-bug-slash',
        'ILUMINACION': 'fas fa-lightbulb',
        'MACETAS': 'fas fa-cube',
        'SUSTRATOS': 'fas fa-layer-group',
        'TABACOS': 'fas fa-smoking',
        'OTROS ARTÍCULOS': 'fas fa-boxes'
      };
      return icons[categoryName] || 'fas fa-tag';
    },

    async loadCategories() {
      try {
        this.isLoadingCategories = true;
        console.log('Cargando categorías...');

        const response = await getCategories();
        this.categories = response.results || response;

        // Process categories and add slugs if missing
        this.categories = this.categories.map(category => ({
          ...category,
          slug: category.slug || this.generateSlug(category.name)
        }));

        console.log('Categorías procesadas:', this.categories);

      } catch (error) {
        console.error('Error loading categories:', error);
        this.categoryError = 'Error al cargar las categorías';
      } finally {
        this.isLoadingCategories = false;
      }
    },

    // Generate slug client side if needed
    generateSlug(name) {
      return name
        .toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w-]+/g, '')        // Remove all non-word chars
        .replace(/--+/g, '-')           // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
    },

    // Esta función es crítica para comprobar si una categoría tiene subcategorías
    hasSubcategories(categoryId) {
      const hasChildren = this.categories.some(cat => cat.parent === categoryId);
      return hasChildren;
    },

    // Asegurar que estas funciones funcionan correctamente
    getDirectSubcategories(parentId) {
      const subcats = this.categories.filter(cat => cat.parent === parentId);
      return subcats;
    },

    // Método mejorado para obtener subcategorías anidadas
    getNestedSubcategories(parentId) {
      // Obtener las subcategorías directas
      const directSubcats = this.getDirectSubcategories(parentId);

      // Para cada subcategoría directa, agregar sus propias subcategorías
      return directSubcats.map(subcat => ({
        ...subcat,
        children: this.categories.filter(cat => cat.parent === subcat.id)
      }));
    },

    toggleMiniCart() {
      this.isMiniCartOpen = !this.isMiniCartOpen;
    },
    closeMiniCart() {
      this.isMiniCartOpen = false;
    },
  },
};
</script>

<style scoped>
/* Estilos del banner promocional */
.promo-banner {
  background-color: var(--primary-dark); /* Semi-transparente */
  padding: 0;
  font-size: 14px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.promo-banner.scrolled {
  border-bottom: 1px solid rgb(255, 255, 255);
}

.promo-banner.scrolled .text-white {
  color: #fff !important;
}

.promo-banner.scrolled a.text-white {
  color: #fff !important;
}

.promo-banner.scrolled a.text-white:hover {
  color: var(--primary-color) !important;
  opacity: 1;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-link {
  color: var(--text-dark);
  text-decoration: none;
  transition: opacity 0.3s ease;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-link:hover {
  opacity: 0.8;
  background-color: rgba(255, 255, 255, 0.2);
}

.timer-container {
  display: flex;
  align-items: center;
}

.timer-box {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 2px 6px;
  margin: 0 4px;
  font-weight: bold;
}

/* Estilos del menú superior */
.top-menu {
  background-color: #f8f9fa;
  padding: 8px 20px;
  font-size: 13px;
}

.top-menu-links {
  display: flex;
  align-items: center;
}

.top-menu-link {
  color: #6c757d;
  margin-right: 15px;
  text-decoration: none;
}

.top-menu-link:hover {
  color: #6a42b9;
}

.delivery-time {
  color: #6c757d;
  margin-left: 10px;
}

.highlight {
  color: #ff6b6b;
  font-weight: bold;
}

.top-menu-right {
  display: flex;
  align-items: center;
}

.language-selector,
.currency-selector {
  margin-right: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.language-selector i,
.currency-selector i {
  font-size: 10px;
  margin-left: 5px;
}

.tracking-link {
  color: #6c757d;
  text-decoration: none;
}

/* Estilos del navbar principal */
.navbar-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1050;
  background: transparent;
}

.navbar {
  padding: 15px 20px;
  background-color: transparent !important;
  transition: background-color 0.3s ease, color 0.3s ease;
  box-shadow: none;
}

/* Estilo para navbar después de scroll */
.navbar-scrolled {
  background-color: rgb(255, 255, 255) !important;
  color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.navbar-brand,
.user-account,
.account-label,
.nav-actions i,
.nav-actions .navbar-svg-icon,
.mobile-actions i,
.mobile-actions .navbar-svg-icon,
.mobile-icon-btn .navbar-svg-icon,
a {
  color: #fff !important;
}

.navbar-svg-icon {
  transition: color 0.3s ease;
  display: block;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
}
.nav-link{
  font-weight: 500;
}
/* Cambios de color cuando se hace scroll */
.navbar-scrolled .navbar-brand,
.navbar-scrolled .user-account,
.navbar-scrolled .account-label,
.navbar-scrolled .nav-actions i,
.navbar-scrolled .nav-actions .navbar-svg-icon,
.navbar-scrolled .mobile-actions i,
.navbar-scrolled .nav-link {
  color: #000 !important;
}
.nav-link:hover {
  opacity: .8;
  background: none;
}

.navbar-scrolled .desktop-search-btn .navbar-svg-icon {
  color: #000 !important;
}
.account-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.account-label {
  font-weight: 500;
  font-size: 0.9rem;
  color: #fff;
}

.brand-container {
  display: flex;
  align-items: center;
}

.logo-img {
  width: 180px;
  height: auto;
  margin-right: 8px;
}

.brand-name {
  font-size: 20px;
  font-weight: bold;
  color: var(--navbar-text);
}

.location-selector {
  display: flex;
  align-items: center;
  margin-left: 15px;
  font-size: 13px;
  color: var(--navbar-icon);
  cursor: pointer;
  border-left: 1px solid var(--navbar-border);
  padding-left: 15px;
}

.location-selector i {
  margin-right: 5px;
  color: var(--primary-color);
}

.location-text {
  font-weight: bold;
  margin: 0 5px;
}

/* Barra de búsqueda */
.search-container {
  flex-grow: 1;
  max-width: 500px;
  margin: 0 30px;
}

.search-input {
  border-radius: 20px 0 0 20px;
  border: 1px solid var(--navbar-border);
  padding-left: 15px;
  height: 42px;
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

.search-btn {
  background-color: var(--black-color) !important;
  /* Forzar el color */
  color: var(--white-color) !important;
  border-radius: 0 20px 20px 0;
  border: none;
  width: 50px;
  transition: background-color 0.3s ease;
}

.search-btn:hover {
  background-color: var(--primary-dark) !important;
}

/* Estilo para botón de búsqueda en navbar oscuro */
.navbar-scrolled .search-btn {
  background-color: var(--primary-color) !important;
}

/* Íconos de acciones */
.nav-actions {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-left: 2rem;
}

/* Transiciones para los íconos de acciones */
.nav-actions i,
.user-account,
.cart-icon,
.account-label,
.account-text {
  transition: color 0.3s ease;
}

.user-account {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.user-account:hover {
  opacity: 0.8;
}

.account-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.account-label {
  font-weight: 500;
  font-size: 0.9rem;
  color: var(--text-dark);
}

.account-role {
  font-size: 0.7rem;
  padding: 2px 6px;
  border-radius: 12px;
}

.wishlist-icon,
.cart-icon {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  text-decoration: none;
}

.wishlist-icon i,
.cart-icon i {
  font-size: 22px;
  color: var(--navbar-icon);
}

.wishlist-icon:hover,
.cart-icon:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.wishlist-count,
.cart-count {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: var(--primary-color) !important;
  /* Cambiado a color pastel */
  color: var(--white-color);
  font-size: 10px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

/* Menú de categorías */
.category-menu {
  background-color: var(--navbar-bg);
  padding: 0 20px;
  position: relative;
  overflow: visible;
  transition: background-color 0.3s ease, color 0.3s ease;
}


.navbar-scrolled+.category-menu {
  background-color: #000;
}

.navbar-scrolled+.category-menu .category-item a {
  color: #fff;
}

.navbar-scrolled+.category-menu .category-item a:hover {
  color: var(--primary-color);
}

.category-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.category-item {
  margin-right: 25px;
  position: relative;
}

.category-item a {
  display: block;
  padding: 15px 0;
  color: var(--navbar-text);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.85rem;
  text-transform: capitalize;
}

.category-item a:hover {
  color: var(--primary-color);
}

/* Mejoras a los estilos del dropdown */
.mega-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: max-content;
  min-width: 400px;
  max-width: 800px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  padding: 20px;
  transform: translateY(10px);
  max-height: 80vh;
  overflow-y: auto;
}

.mega-dropdown.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-toggle .fa-chevron-down {
  font-size: 0.7rem;
  transition: transform 0.3s ease;
}

.dropdown-toggle::after {
  display: none;
}

.has-dropdown:hover .dropdown-toggle .fa-chevron-down {
  transform: rotate(-180deg);
}

.subcategories-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  width: 100%;
}

.subcategory-column {
  padding: 6px;
}

.subcategory-title {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: var(--text-dark);
  text-decoration: none;
  padding: 10px;
  border-radius: 6px;
  transition: all 0.2s ease;
  background-color: rgba(0, 0, 0, 0.04);
  margin-bottom: 0;
  width: 100%;
  white-space: normal;
  line-height: 1.2;
}

.subcategory-title:hover {
  background-color: rgba(0, 0, 0, 0.08);
  color: var(--primary-color);
  transform: translateX(5px);
}

.all-products {
  color: var(--primary-color) !important;
  font-weight: 600 !important;
}

/* Mobile Improvements */
@media (max-width: 991.98px) {
  .mega-dropdown {
    position: static;
    transform: none;
    box-shadow: none;
    padding: 0;
    max-width: 100%;
  }

  .mega-content {
    grid-template-columns: 1fr;
  }

  .category-section {
    padding: 12px;
    background: none;
  }

  .subcategories-grid {
    gap: 12px;
  }

  .category-main-title {
    font-size: 1rem;
    margin-bottom: 12px;
  }

  .subcategory-title {
    font-size: 0.9rem;
  }

  .subcategory-item {
    font-size: 0.85rem;
  }
}

/* Mobile menu and other existing styles */
.mobile-menu-toggle,
.mobile-icon-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.mobile-icon-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.navbar-scrolled .mobile-icon-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.navbar-scrolled .mobile-icon-btn i,
.navbar-scrolled .mobile-icon-btn .navbar-svg-icon {
  color: #000 !important;
}

.mobile-menu-toggle i.fa-times {
  transform: rotate(0deg);
}


/* Promo banner items */
.promo-item {
  display: flex;
  align-items: center;
}

/* Enhanced mobile menu appearance */
@media (max-width: 991.98px) {
  .navbar {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .logo-img {
    width: 120px;
  }

  .navbar-brand {
    margin-right: 0;
  }

  .mobile-actions {
    gap: 5px;
  }
}

/* ===== OFFCANVAS MENU (MOBILE) ===== */
.offcanvas-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 360px;
  height: 100vh;
  background-color: #fff;
  z-index: 1050;
  overflow-y: auto;
  transform: translateX(100%);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.offcanvas-menu.show {
  transform: translateX(0);
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  z-index: 1045;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.35s ease;
  pointer-events: none;
}

.offcanvas-backdrop.show {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.offcanvas-header {
  padding: 1.25rem 1.25rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.offcanvas-header .offcanvas-title {
  color: #111;
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0;
}

.offcanvas-header .btn-close {
  filter: none;
  opacity: 0.5;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}

.offcanvas-header .btn-close:hover {
  opacity: 1;
}

.offcanvas-body {
  padding: 1.25rem;
  overflow-y: auto;
  flex: 1;
}

.offcanvas-footer {
  padding: 1rem 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

/* Mobile user account */
.mobile-user-account {
  margin-bottom: 1.25rem !important;
}

.mobile-user-account a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #111 !important;
  background-color: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 0.85rem 1rem;
  transition: background-color 0.2s ease;
}

.mobile-user-account a:hover,
.mobile-user-account a:active {
  background-color: rgba(0, 0, 0, 0.07);
}

.mobile-user-account i.fas {
  font-size: 1.1rem;
  color: var(--primary-color) !important;
}

.mobile-user-account .text-muted {
  color: rgba(0,0,0,0.4) !important;
  font-size: 0.75rem;
}

.mobile-user-account .fa-chevron-right {
  color: rgba(0, 0, 0, 0.25) !important;
  font-size: 0.75rem;
}

/* Mobile search inside offcanvas */
.offcanvas-body .search-container {
  max-width: 100%;
  margin: 0 0 1.25rem;
}

.offcanvas-body .search-input {
  background-color: #f5f5f5 !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  color: #111 !important;
  border-radius: 8px 0 0 8px;
  height: 42px;
}

.offcanvas-body .search-input::placeholder {
  color: rgba(0, 0, 0, 0.35);
}

.offcanvas-body .search-input:focus {
  background-color: #fff !important;
  border-color: var(--primary-color) !important;
  box-shadow: none;
  outline: none;
}

.offcanvas-body .search-btn {
  background-color: var(--primary-color) !important;
  color: #fff !important;
  border-radius: 0 8px 8px 0;
  border: none;
  width: 46px;
}

/* Mobile nav links */
.mobile-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.9rem;
  color: #111 !important;
  text-decoration: none !important;
  font-weight: 500;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  border-radius: 8px;
  transition: background-color 0.2s ease, color 0.2s ease;
  width: 100%;
}

.mobile-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #000 !important;
}

.mobile-menu-item {
  margin-bottom: 2px;
}

/* Mobile accordion (categories with subcategories) */
.offcanvas-menu .accordion-item {
  background: transparent;
  border: none !important;
  margin-bottom: 2px;
}

.offcanvas-menu .accordion-button {
  background-color: transparent !important;
  color: #111 !important;
  font-weight: 500;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  padding: 0.75rem 0.9rem;
  border-radius: 8px !important;
  box-shadow: none !important;
  border: none !important;
  width: 100%;
}

.offcanvas-menu .accordion-button:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #000 !important;
}

.offcanvas-menu .accordion-button:not(.collapsed) {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: var(--primary-color) !important;
}

.offcanvas-menu .accordion-button::after {
  filter: none;
  opacity: 0.5;
}

.offcanvas-menu .accordion-button:not(.collapsed)::after {
  filter: none;
  opacity: 1;
}

.offcanvas-menu .accordion-body {
  background: transparent;
  padding: 0 0 0.25rem;
}

/* Mobile submenu items */
.mobile-submenu-items,
.offcanvas-menu .submenu-items {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 1rem;
  border-left: 2px solid rgba(0,0,0,0.08);
  margin-left: 1.2rem;
}

.mobile-subcategory-link {
  display: block;
  width: 100%;
  color: #444 !important;
  text-decoration: none !important;
  padding: 0.5rem 0.75rem !important;
  font-size: 0.82rem !important;
  border-radius: 6px;
  transition: background-color 0.15s ease, color 0.15s ease;
  border-bottom: none !important;
  background-color: transparent !important;
}

.mobile-subcategory-link:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #000 !important;
}

.subcategory-parent-link {
  font-weight: 600 !important;
  color: #222 !important;
}

.mobile-subcategory-children {
  display: flex !important;
  flex-direction: column !important;
  padding-left: 0.75rem !important;
  border-left: 1px solid rgba(0,0,0,0.07);
  margin-left: 0.5rem;
}

.mobile-grandchild-link {
  color: #666 !important;
  font-size: 0.78rem !important;
  text-decoration: none !important;
  padding: 0.35rem 0.6rem !important;
  border-radius: 5px;
  transition: color 0.15s ease, background-color 0.15s ease;
  border-bottom: none !important;
}

.mobile-grandchild-link:hover {
  color: #111 !important;
  background-color: rgba(0,0,0,0.04) !important;
}

.subcategory-with-children {
  display: flex;
  flex-direction: column;
  border-bottom: none !important;
}

/* Social links in footer */
.social-links-mobile {
  display: flex;
  gap: 0.75rem;
}

.social-link-mobile {
  color: #555 !important;
  text-decoration: none;
  font-size: 1.1rem;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.social-link-mobile:hover {
  background-color: var(--primary-color) !important;
  color: #fff !important;
}

.offcanvas-footer small {
  color: rgba(0,0,0,0.35) !important;
}

/* Info Links Styles */
.info-links {
  gap: 1.25rem;
}

.info-link {
  color: var(--text-dark);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
}

.info-link:hover {
  color: var(--primary-color);
}

.info-link i {
  font-size: 0.9rem;
}


/* Skeleton Loaders for Category Menu */
.skeleton-item {
  display: flex;
  align-items: center;
}

.skeleton-link {
  display: flex;
  align-items: center;
  width: 120px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
  margin-right: 8px;
}

.skeleton-text {
  height: 14px;
  width: 80px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.mobile-skeleton-menu {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
}

.mobile-skeleton-item {
  padding: 8px 0;
}

.skeleton-button {
  height: 40px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.6;
  }
}

/* Resaltar más el menú activo */
.has-dropdown {
  position: relative;
}

.has-dropdown::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--primary-color);
  transition: width 0.3s ease;
}

.has-dropdown:hover::after,
.has-dropdown:focus-within::after {
  width: 100%;
}

/* Desktop Search Button */
.desktop-search-btn {
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.desktop-search-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.desktop-offcanvas-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 340px;
  height: 100vh;
  background-color: #fff;
  z-index: 1050;
  overflow-y: auto;
  transform: translateX(100%);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.desktop-offcanvas-menu.show {
  transform: translateX(0);
}

.desktop-offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  z-index: 1045;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.35s ease;
  pointer-events: none;
}

.desktop-offcanvas-backdrop.show {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.desktop-menu-item {
  margin-bottom: 2px;
}

.desktop-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.9rem;
  color: #111 !important;
  text-decoration: none !important;
  font-weight: 500;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  border-radius: 8px;
  transition: background-color 0.2s ease, color 0.2s ease;
  width: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
}

.desktop-link:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #000 !important;
}

.desktop-skeleton-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 8px 0;
}

.desktop-skeleton-item {
  padding: 4px 0;
}

/* Desktop accordion */
.desktop-offcanvas-menu .accordion-item {
  background: transparent;
  border: none !important;
  margin-bottom: 2px;
}

.desktop-offcanvas-menu .accordion-button {
  padding: 0.75rem 0.9rem;
  font-weight: 500;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  color: #111 !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  border: none !important;
  width: 100%;
  text-transform: none;
}

.desktop-offcanvas-menu .accordion-button:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #000 !important;
}

.desktop-offcanvas-menu .accordion-button:not(.collapsed) {
  color: var(--primary-color) !important;
  background-color: rgba(0, 0, 0, 0.04) !important;
  box-shadow: none !important;
}

.desktop-offcanvas-menu .accordion-button:focus {
  box-shadow: none;
  border-color: transparent;
}

.desktop-offcanvas-menu .accordion-button::after {
  filter: none;
  opacity: 0.5;
}

.desktop-offcanvas-menu .accordion-button:not(.collapsed)::after {
  opacity: 1;
  transform: rotate(-180deg);
}

.desktop-offcanvas-menu .accordion-body {
  background: transparent;
  padding: 0 0 0.25rem;
}

.desktop-offcanvas-menu .submenu-items {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 0.75rem;
  border-left: 2px solid rgba(0,0,0,0.08);
  margin-left: 1.5rem;
}

.desktop-offcanvas-menu .submenu-link {
  display: block;
  padding: 0.5rem 0.75rem;
  color: #444 !important;
  text-decoration: none !important;
  font-size: 0.82rem;
  border-radius: 6px;
  transition: background-color 0.15s ease, color 0.15s ease;
  margin-bottom: 1px;
}

.desktop-offcanvas-menu .submenu-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #000 !important;
  padding-left: 1rem;
}

/* Estilos específicos para mobile */
@media (max-width: 991.98px) {
  /* already handled by the unified dark theme above */
}
</style>
